import { FormattedMessage } from 'react-intl';
import Icon from '../../../../../assets/icons/legacy/video.svg';
export const EnabledCamera = () => {
    return (<>
      <Icon />
      <FormattedMessage id="notification.video-active{linebreak}" tagName="p" values={{
            linebreak: <br />,
        }}/>
    </>);
};
